import { ListingImage } from '@zoopla/listings/image';
import {
    Skeleton,
    SkeletonBlock,
    SkeletonRow,
    SkeletonItem
} from '../Skeleton/Skeleton';
import { StyledListingCardMiniDetails } from './ListingCardMini.styles';
import { ListingCardMini } from './ListingCardMini';

export const ListingCardMiniSkeleton = () => {
    return (
        <Skeleton aria-hidden>
            <ListingCardMini testId="listing-card-mobile-skeleton">
                <ListingImage useImagePlaceholder={false} />
                <StyledListingCardMiniDetails>
                    <SkeletonBlock>
                        <SkeletonRow itemHeight={2}>
                            <SkeletonItem size={18} />
                        </SkeletonRow>
                        <SkeletonRow itemHeight={2}>
                            <SkeletonItem size={12} />
                        </SkeletonRow>
                        <SkeletonRow itemHeight={2} spacing={2}>
                            <SkeletonItem size={4} />
                            <SkeletonItem size={4} />
                            <SkeletonItem size={4} />
                        </SkeletonRow>
                    </SkeletonBlock>
                </StyledListingCardMiniDetails>
            </ListingCardMini>
        </Skeleton>
    );
};
